// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { QuickTableUtils } from '../QuickTableUtils';
import { SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '../../../misc/ThemeManager';
export class StrikePriceColumnRenderer {
    constructor() {
        this._lastHoveredRow = null;
        this._lastHoveredCellRect = null;
        this._isTooltipShown = false;
    }
    DrawCell(context, eventArgs) {
        const strikePriceTooltip = this.getInfoIconTooltipText(eventArgs.row.item);
        if (!isValidString(strikePriceTooltip)) {
            return;
        }
        const cellRect = new Rectangle(eventArgs.x, eventArgs.y, eventArgs.width, eventArgs.height);
        const xPadding = eventArgs.table.getXPadding(eventArgs.columnIndex, context.textAlign);
        const yPadding = eventArgs.table.getYPadding(cellRect.Height, QuickTableUtils.GetTextHeight(context));
        const rectBrush = new SolidBrush(eventArgs.BackColor);
        context.FillRectWithRect(rectBrush, cellRect);
        const textBrush = new SolidBrush(eventArgs.ForeColor);
        QuickTableUtils.DrawTextInRect(context, eventArgs.cell.formattedValue, eventArgs.font, textBrush, cellRect.X, cellRect.Y, cellRect.Width, cellRect.Height, xPadding, yPadding, true);
        const infoIconRectangle = this.getInfoIconRectangle(eventArgs.table, cellRect);
        const isHoveredInfoIcon = infoIconRectangle.Contains(eventArgs.lastMouseMoveX, eventArgs.lastMouseMoveY);
        const image = isHoveredInfoIcon
            ? ThemeManager.NewImages.infoIconHovered
            : ThemeManager.NewImages.infoIconDefault;
        context.DrawCenteredImage(image.image, infoIconRectangle);
        if (this._lastHoveredRow === eventArgs.row) {
            this._lastHoveredCellRect = cellRect;
        }
        eventArgs.handled = true;
    }
    ProcessMouseMove(eventArgs) {
        // Last hovered row changed.
        eventArgs.isTooltipHandled = true;
        const row = eventArgs.row;
        if (this._lastHoveredRow !== row) {
            this._lastHoveredRow = row;
            this._lastHoveredCellRect = null;
            eventArgs.needRedraw = true;
            this.hideInfoIconTooltip();
            return;
        }
        // Last hovered cell rect is not set, need wait for cell redraw.
        if (isNullOrUndefined(this._lastHoveredCellRect)) {
            eventArgs.needRedraw = true;
            this.hideInfoIconTooltip();
            return;
        }
        const infoIconRectangle = this.getInfoIconRectangle(eventArgs.table, this._lastHoveredCellRect);
        const showTooltip = infoIconRectangle.Contains(eventArgs.lastMouseMoveX, eventArgs.lastMouseMoveY);
        //Changed hovered info icon state.
        if (showTooltip !== this._isTooltipShown) {
            eventArgs.needRedraw = true;
            if (showTooltip) {
                this.showInfoIconTooltip(this.getInfoIconTooltipText(this._lastHoveredRow.item));
            }
            else {
                this.hideInfoIconTooltip();
            }
        }
    }
    ProcessMouseLeave(eventArgs) {
        if (this._isTooltipShown) {
            eventArgs.needRedraw = true;
        }
        this._lastHoveredRow = null;
        this._lastHoveredCellRect = null;
        this.hideInfoIconTooltip();
    }
    getInfoIconRectangle(table, cellRect) {
        const buttonRect = table.getButtonRectangle(cellRect.X, cellRect.Y, cellRect.Width, cellRect.Height);
        buttonRect.X = cellRect.Right() - buttonRect.Width;
        return buttonRect;
    }
    getInfoIconTooltipText(item) {
        var _a;
        return (_a = item === null || item === void 0 ? void 0 : item.getStrikePriceTooltip) === null || _a === void 0 ? void 0 : _a.call(item);
    }
    showInfoIconTooltip(tooltip) {
        if (!isValidString(tooltip)) {
            return;
        }
        this._isTooltipShown = true;
        showTooltip(null, tooltip);
    }
    hideInfoIconTooltip() {
        if (!this._isTooltipShown) {
            return;
        }
        this._isTooltipShown = false;
        hideTooltip();
    }
}
